/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   File:   attorney-tabs.js
 *   Desc:   This widget implements ARIA Authoring Practices to Tab Element
 */

export default class AttorneyTabs {
	start(groupNode) {
		this.tablistNode = groupNode;
		this.orientation = this.tablistNode.getAttribute('aria-orientation');

		this.tabs = [];
		this.firstTab = null;
		this.lastTab = null;

		this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
		this.tabpanels = [];

		for (let i = 0; i < this.tabs.length; i += 1) {
			const tab = this.tabs[i];
			const tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

			tab.tabIndex = -1;
			tab.setAttribute('aria-selected', 'false');
			this.tabpanels.push(tabpanel);

			tab.addEventListener('keydown', this.onKeydown.bind(this));
			tab.addEventListener('click', this.onClick.bind(this));

			if (!this.firstTab) {
				this.firstTab = tab;
			}
			this.lastTab = tab;
		}

		this.setSelectedTab(this.firstTab);
	}

	setSelectedTab(currentTab) {
		for (let i = 0; i < this.tabs.length; i += 1) {
			const tab = this.tabs[i];
			if (currentTab === tab) {
				tab.setAttribute('aria-selected', 'true');
				tab.tabIndex = 0;
				this.tabpanels[i].classList.remove('is-hidden');
				this.tabpanels[i].tabIndex = 0;
			} else {
				tab.setAttribute('aria-selected', 'false');
				tab.tabIndex = -1;
				this.tabpanels[i].classList.add('is-hidden');
				this.tabpanels[i].tabIndex = -1;
			}
		}
	}

	moveFocusToTab(currentTab) {
		currentTab.focus();
	}

	moveFocusToPreviousTab(currentTab) {
		let index;

		if (currentTab === this.firstTab) {
			this.moveFocusToTab(this.lastTab);
		} else {
			index = this.tabs.indexOf(currentTab);
			this.moveFocusToTab(this.tabs[index - 1]);
		}
	}

	moveFocusToNextTab(currentTab) {
		let index;

		if (currentTab === this.lastTab) {
			this.moveFocusToTab(this.firstTab);
		} else {
			index = this.tabs.indexOf(currentTab);
			this.moveFocusToTab(this.tabs[index + 1]);
		}
	}

	/* EVENT HANDLERS */
	onKeydown(event) {
		const tgt = event.currentTarget;
		let	flag = false;

		switch (event.key) {
		case 'ArrowLeft':
			if (this.orientation === 'horizontal') {
				this.moveFocusToPreviousTab(tgt);
				flag = true;
			}
			break;

		case 'ArrowRight':
			if (this.orientation === 'horizontal') {
				this.moveFocusToNextTab(tgt);
				flag = true;
			}
			break;

		case 'ArrowUp':
			if (this.orientation === 'vertical') {
				this.moveFocusToPreviousTab(tgt);
				flag = true;
			}
			break;

		case 'ArrowDown':
			if (this.orientation === 'vertical') {
				this.moveFocusToNextTab(tgt);
				flag = true;
			}
			break;

		case 'Home':
			this.moveFocusToTab(this.firstTab);
			flag = true;
			break;

		case 'End':
			this.moveFocusToTab(this.lastTab);
			flag = true;
			break;

		default:
			break;
		}

		if (flag) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	// Since buttons are being used for the tabs, the click also is activated
	// with the space and enter keys
	onClick(event) {
		this.setSelectedTab(event.currentTarget);
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/attorney-tabs.js